import { Controller } from "@hotwired/stimulus"

// Mobile action bar — auto-hides on scroll DOWN to free reading space,
// reappears on scroll UP (iOS/Android convention).
// Uses negative margin-top to collapse inside the parent bottom-nav container
// (translate-y-full doesn't work inside overflow-hidden fixed containers).
export default class extends Controller {
  static values = {
    hideThreshold: { type: Number, default: 100 },
    hysteresis: { type: Number, default: 20 }
  }

  connect() {
    this._lastY = window.scrollY
    this._ticking = false
    this._hidden = false
    // Measure own height for negative margin.
    this._height = this.element.offsetHeight
    // Reset on Turbo cache restore — snapshot may have stale inline style.
    this.element.style.marginTop = ""
    this._scroll = this._scroll.bind(this)
    window.addEventListener("scroll", this._scroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this._scroll)
  }

  _scroll() {
    if (this._ticking) return
    this._ticking = true
    window.requestAnimationFrame(() => this._update())
  }

  _update() {
    const y = window.scrollY
    const goingDown = y > this._lastY
    const goingUp = y < this._lastY
    const threshold = this.hideThresholdValue
    const hysteresis = this.hysteresisValue

    if (goingDown && y > threshold + hysteresis && !this._hidden) {
      this.element.style.marginTop = `-${this._height}px`
      this._hidden = true
    } else if (goingUp && this._hidden) {
      this.element.style.marginTop = ""
      this._hidden = false
    }

    this._lastY = y
    this._ticking = false
  }
}
